import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  display: flex;
  row-gap: 15px;
  column-gap: 15px;
`

export const StyleNone = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${(props: any) => props.theme.colors.inputBorder};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
